import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'
import { GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS, GUI_LIVE_VIEW_BREAKPOINT_XXS } from '../utils/breakpoints'
/* eslint-disable tss-unused-classes/unused-classes */
export const useAnimationStyles = makeStyles<{ direction?: 'in' | 'out' }>()((theme, props) => ({
  directionIndicator: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  directionIndicatorShort: {
    width: 10,
  },
  directionIndicatorHorizontal: {
    [theme.breakpoints.up('md')]: {
      top: 3,
    },
  },
  curvedArrowAnimation: {
    offsetPath: 'path("M18 75.5V17.5C18 11.9772 13.5228 7.5 8 7.5H3")',
    animation: createAnimation(props.direction, animationIn, animationOut, 3),
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },

    [theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XXS)]: {
      offsetPath: 'path("M48 75.5V22.5C48 14.2157 41.2843 7.5 33 7.5H3")',
    },

    [theme.breakpoints.between(GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS)]: {
      offsetPath: 'path("M48 75.5V22.5C48 14.2157 41.2843 7.5 33 7.5H3")',
    },

    [theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XS)]: {
      offsetPath: 'path("M61.5 77.5V22.5C61.5 14.2157 54.7843 7.5 46.5 7.5H1.5")',
    },
  },
  curvedSideArrowAnimation: {
    offsetPath:
      'path("M7.49976 50L7.49976 29.5067C7.49976 21.2225 14.2155 14.5067 22.4998 14.5067L81.7464 14.5067C85.4761 14.5067 88.4997 11.4831 88.4996 7.75337V7.75337L88.4994 1")',
    animation: createAnimation(props.direction, animationIn, animationOut, 6),
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },

    [theme.breakpoints.between(GUI_LIVE_VIEW_BREAKPOINT_XXS, GUI_LIVE_VIEW_BREAKPOINT_XS)]: {
      offsetPath:
        'path("M7.50024 50.0002L7.50024 29.507C7.50024 21.2227 14.216 14.507 22.5002 14.507L103.247 14.507C106.977 14.507 110 11.4834 110 7.75362V7.75362L110 1.00025")',
    },

    [theme.breakpoints.between(GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS)]: {
      offsetPath:
        'path("M7.50024 50.0002L7.50024 29.507C7.50024 21.2227 14.216 14.507 22.5002 14.507L103.247 14.507C106.977 14.507 110 11.4834 110 7.75362V7.75362L110 1.00025")',
    },

    [theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XS)]: {
      offsetPath:
        'path("M7.49754 51.0001L7.49754 30.1447C7.49754 21.8605 14.2133 15.1447 22.4975 15.1447L124.675 15.1447C128.443 15.1447 131.497 12.0903 131.497 8.32246V8.32246L131.497 1.50018")',
    },

    [theme.breakpoints.up('md')]: {
      offsetPath: 'path("M127.5 7.49548H105C96.7157 7.49548 90 14.2112 90 22.4955V121.995C90 130.28 83.2843 136.995 75 136.995H1.5")',
    },
  },
  curvedBottomArrow360Animation: {
    offsetPath: 'path("M1 50V29.507C1 21.2227 7.716 14.507 16 14.507H114.247C117.977 14.507 121 11.4834 121 7.75362V1")',
    animation: createAnimation(props.direction, animationIn, animationOut, 4),
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  },
  sideArrowAnimation: {
    offsetPath: 'path("M7.50024 50L7.50025 25.6976L7.50025 0.999999")',
    animation: createAnimation(props.direction, animationIn, animationOut, 3),
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },

    [theme.breakpoints.up('md')]: {
      offsetPath: 'path("M126.001 7.49841H64.501H2.00098")',
    },
  },
  straightArrowAnimation: {
    offsetPath: 'path("M126.001 7.498h-124")',
    animation: createAnimation(props.direction, animationIn, animationOut, 2),
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  },
  straightArrowShortAnimation: {
    offsetPath: 'path("M7.50391 37.9999L7.50391 20.641L7.5039 2.99988")',
    animation: createAnimation(props.direction, animationShortIn, animationShortOut, 2),
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  },
}))

const animationIn = keyframes`
  0% { opacity: 0; offset-distance: 0%; }
  10% { opacity: 1; offset-distance: 10%; }
  90% { opacity: 1; offset-distance: 90%; }
  95% { opacity: 0; offset-distance: 95%; }
  100% { opacity: 0; offset-distance: 100%; }
`
const animationOut = keyframes`
  0% { opacity: 0; offset-distance: 100%; }
  10% { opacity: 1; offset-distance: 90%; }
  90% { opacity: 1; offset-distance: 10%; }
  95% { opacity: 0; offset-distance: 5%; }
  100% { opacity: 0; offset-distance: 0%; }
`

const animationShortIn = keyframes`
  0% { opacity: 0; offset-distance: 0%; }
  10% { opacity: 1; offset-distance: 10%; }
  90% { opacity: 1; offset-distance: 75%; }
  95% { opacity: 0; offset-distance: 80%; }
  100% { opacity: 0; offset-distance: 83%; }
`
const animationShortOut = keyframes`
  0% { opacity: 0; offset-distance: 83%; }
  10% { opacity: 1; offset-distance: 80%; }
  90% { opacity: 1; offset-distance: 10%; }
  95% { opacity: 0; offset-distance: 5%; }
  100% { opacity: 0; offset-distance: 0%; }
`

const createAnimation = (
  direction: 'in' | 'out' | undefined,
  animationIn: ReturnType<typeof keyframes>,
  animationOut: ReturnType<typeof keyframes>,
  duration: number
): string => {
  if (!direction) return 'none'

  const animation = direction === 'in' ? animationIn : animationOut
  return `${animation} ${duration}s linear 0.5s infinite`
}
